module.exports = __webpack_public_path__ + "media/images/smart_phone/login/202001/logo_03-a8988defc151cdcd5ca3ac4014c3aab2.png";